exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.px20-xs[data-v-4e355186]{padding-left:20px;padding-right:20px}}.blik-text[data-v-4e355186]{-ms-flex-direction:column;flex-direction:column}.banks__link img[data-v-4e355186]{width:80%;margin:0 auto;text-align:center;height:auto;display:block;margin-bottom:10px}.blik__header[data-v-4e355186]{font-size:30px;text-transform:none}.blik__close[data-v-4e355186]{color:white;background-color:#da3800;border-radius:20px;margin:0;padding:10px 0;font-size:18px}@media (min-width: 768px){.mx40-sm[data-v-4e355186]{margin-left:40px;margin-right:40px}}\n", ""]);

// exports
